// import React, { createContext, useContext, useState, useMemo, useEffect } from "react";
// import { ThemeProvider } from "@mui/material/styles";
// import CssBaseline from "@mui/material/CssBaseline";
// import { createGoldTheme } from "./goldTheme";

// const ThemeModeContext = createContext({
//   toggleTheme: () => {},
//   mode: "dark",
// });

// export const useThemeMode = () => useContext(ThemeModeContext);

// export const GoldThemeProvider = ({ children }) => {
//   const [mode, setMode] = useState(() => {
//     const savedMode = localStorage.getItem("themeMode");
//     return savedMode === "light" ? "light" : "dark";
//   });

//   useEffect(() => {
//     localStorage.setItem("themeMode", mode);
//   }, [mode]);

//   const themeMode = useMemo(
//     () => ({
//       toggleTheme: () => {
//         setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
//       },
//       mode,
//     }),
//     [mode]
//   );

//   const theme = useMemo(() => createGoldTheme(mode), [mode]);

//   return (
//     <ThemeModeContext.Provider value={themeMode}>
//       <ThemeProvider theme={theme}>
//         <CssBaseline />
//         {children}
//       </ThemeProvider>
//     </ThemeModeContext.Provider>
//   );
// };





import React, { createContext, useContext, useState, useMemo, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { createGoldTheme } from "./goldTheme"; // Linked to your filename

const ThemeModeContext = createContext({
  toggleTheme: () => { },
  mode: "dark",
});

export const useThemeMode = () => useContext(ThemeModeContext);

export const GoldThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(() => {
    // Check both potential storage keys for compatibility
    const savedMode = localStorage.getItem("themeMode") || localStorage.getItem("theme");
    return savedMode === "light" ? "light" : "dark";
  });

  useEffect(() => {
    // Save to local storage
    localStorage.setItem("themeMode", mode);

    // Add light/dark class to the root HTML element (for global CSS/External libs)
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(mode);
  }, [mode]);

  const themeMode = useMemo(
    () => ({
      toggleTheme: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
      mode,
    }),
    [mode]
  );

  const theme = useMemo(() => createGoldTheme(mode), [mode]);

  return (
    <ThemeModeContext.Provider value={themeMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
};